module.exports = __webpack_public_path__ + "static/media/DumpsterFire.974567dd.svg";